export const ONEFINITY_CHAIN_ID = "0xf4233";
